module.exports = __webpack_public_path__ + "img/icon_pdf.8e5a0148.svg";